module.exports = __webpack_public_path__ + "assets/88ce568bac3eede8db34f49a00734016.png";